export class ConjuntoCategoriaContabil {
    id: number;
    idCategoriaOrigem: number;
    idCategoriaDestino: number;
    argumentos: string[];
    ativo: boolean;
    idTipoLancamento?: number;
}
